import React from 'react';

import styled from 'styled-components';

import SelectAdvancedFilter from 'components/lib/SelectAdvancedFilter';
import ShopRequestsCompanyFilterNoPropagation from 'components/MysteryShopping/Filters/ShopRequestsCompanyFilterNoPropagation';
import { useAppSelector } from 'store/hook';
import { CompanyType } from 'types/company';

import { useShopRequestsDataContext } from '../ShopRequestsDataContext';

const StyledFilter = styled(SelectAdvancedFilter)`
  margin-right: 5px;
`;

const ShopRequestsCompanyFilter = () => {
  const { companies } = useAppSelector((state) => state.global);
  const { filters, setFilters } = useShopRequestsDataContext();

  const onChange = (values: any[]) => {
    setFilters({ ...filters, companyIds: values.map((item: any) => item.value) });
  };

  const setNoPropagation = (checked: boolean) => {
    setFilters({ ...filters, noPropagation: checked });
  };

  return (
    <StyledFilter
      options={companies?.map((company: CompanyType) => ({ value: company.id, label: company.name })) ?? []}
      otherOptions={
        <ShopRequestsCompanyFilterNoPropagation
          checked={Boolean(filters.noPropagation)}
          dataTestId="sr-filter-company-no-propagation"
          onChange={setNoPropagation}
        />
      }
      otherOptionsLabel={filters.noPropagation ? 'No Propagation' : undefined}
      defaultValue={filters.companyIds ?? []}
      onSelect={onChange}
      placeholder="Propagate To Company"
      dataTestId="sr-filter-company"
    />
  );
};

export default ShopRequestsCompanyFilter;
